import React, { FormEvent, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Modal, LinkAsButton } from '@printdeal/ui-library';

import clsx from 'clsx';
import { dispatchDataLayerEntry } from '../../../../../helpers/dataLayerHelpers/productDataLayerHelper';
import { IProductPage } from '../../../../../types/product/productDetailPage';
import { ProductUploadSpecifications } from '../../../detail/ProductUploadSpecifications';

interface Props {
  productPage: IProductPage;
  variant: string;
  pageLayout?: string;
}

const TechnicalDrawingForm = 'technical-drawing-form';

const TechnicalDrawingModal = ({ productPage, variant, pageLayout }: Props) => {
  const {
    productUploadSpecifications, contentful_id: contentfulId, productName,
  } = productPage;
  const [showModal, setShowModal] = useState<boolean>(false);
  const intl = useIntl();

  const toggleModal = (event: FormEvent) => {
    event.preventDefault();

    if (!showModal) {
      // If we're not showing the modal yet it means we're in the process of doing so
      dispatchDataLayerEntry(
        'product_detail_page_textile',
        'technical_drawing',
        { productName, contentfulId, variant },
      );
    }

    setShowModal(!showModal);
  };

  if (!productUploadSpecifications?.uploadSpecifications?.length) return null;

  return (
    <form id={TechnicalDrawingForm} onSubmit={toggleModal}>
      <LinkAsButton className={clsx(pageLayout === 'PPAG' && 'pd-pt-8')} type="submit" form={TechnicalDrawingForm} iconBefore="download" variant="secondary">
        <FormattedMessage id="product.show.technicaldrawing" defaultMessage="Download technical drawings" />
      </LinkAsButton>
      <Modal
        title={intl.formatMessage({ id: 'selector.product.technicaldrawings.title', defaultMessage: 'Technical drawings' })}
        dismissLabel={intl.formatMessage({ id: 'general.alert.dismiss', defaultMessage: 'Dismiss' })}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      >
        <ProductUploadSpecifications uploadSpecifications={productUploadSpecifications?.uploadSpecifications} />
      </Modal>
    </form>
  );
};

export default TechnicalDrawingModal;
